<template>
  <div class="flex items-center" :data-testid="name">
    <SvgIcon
      :width="size"
      :height="size"
      fill="currentColor"
      class="inline-block"
    />
  </div>
</template>

<script setup lang="ts">
import { icons, type IconType } from './icon';
import { computed } from 'vue';

const props = withDefaults(defineProps<{ name: IconType; size?: string }>(), {
  size: '24',
});
const name = computed(() => props.name);
// eslint-disable-next-line @typescript-eslint/naming-convention
const SvgIcon = computed(() => icons[name.value]);
</script>
